"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeCreation = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const Creation_1 = require("../entity/Creation");
const creativeFormat_1 = require("./creativeFormat");
const deliverable_1 = require("./deliverable");
const inspectionModificationRequest_1 = require("./inspectionModificationRequest");
const modificationRequest_1 = require("./modificationRequest");
const organization_1 = require("./organization");
const user_1 = require("./user");
const createSomeCreation = ({ id = '123', assignmentId = '1234567', creationSetId = '1234567', number = 1, assignee = user_1.createSomeOptimizerUser(), creativeFormat = creativeFormat_1.createSomeCreativeFormat(), deliverables = immutable_1.List([deliverable_1.createSomeDelivarable()]), latestProposedDeliverable = deliverable_1.createSomeDelivarable(), modificationRequests = immutable_1.List([modificationRequest_1.createSomeModificationRequest()]), modificationRequestFreeExpiredAt = undefined, modificationRequestPoint = 20, modificationRequestFreeLimit = 2, isNextModificationRequestForAFee = true, inspectionModificationRequests = immutable_1.List([inspectionModificationRequest_1.createSomeInspectionModificationRequest()]), state = Object.keys(Creation_1.CreationState)[1], proposed = false, organization = organization_1.createSomeOrganization(), modificationRequestExpired = false, achievementId = '1234567', } = {}) => new Creation_1.default({
    id,
    assignmentId,
    creationSetId,
    number,
    assignee,
    creativeFormat,
    deliverables,
    latestProposedDeliverable,
    modificationRequests,
    modificationRequestFreeExpiredAt,
    modificationRequestPoint,
    modificationRequestFreeLimit,
    isNextModificationRequestForAFee,
    inspectionModificationRequests,
    state,
    proposed,
    createdAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }),
    submittedAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }),
    stateUpdatedAt: luxon_1.DateTime.fromMillis(10, { zone: 'utc' }),
    organization,
    modificationRequestExpired,
    achievementId,
});
exports.createSomeCreation = createSomeCreation;
